export default __webpack_public_path__ + "static/media/logo-white-.754000f3.png";